import { get, post } from "./http-services";

export function findByConfigName(configName) {
    return get(`/config/byname?configName=${configName}`);
}
export function saveConfigName(configModel) {
    return post(`/config`, configModel);
}